import React, { useEffect, useState, useRef } from "react";
import Card from "Front/components/Card/Card.jsx";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-switch/dist/css/bootstrap3/react-bootstrap-switch.min.css";
import * as API from '../../../api/billing'
import Loading from "react-loading";
import NotificationSystem from "react-notification-system";
import { style } from "Admin/variables/Variables.jsx";
import Datetime from 'react-datetime';
import moment from 'moment';
import { Grid, Row, Col, FormGroup, ControlLabel, Modal, FormControl } from 'react-bootstrap';
import Button from "Admin/elements/CustomButton/CustomButton.jsx";
import Bill from "./Bill";
import BillPartPayment from "./BillPartPayment";
import { useHistory } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import MoreMenu from "./MoreMenu";
import Print from "./Print";
import BillRefund from "./BillRefund";
import PatientRegistration from "../../Home/PatientRegistrationPopup";


const BillingList = ({ startDate, endDate, setStartDate, setEndDate }) => {
    const start_date = moment(startDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('YYYY-MM-DD');
    const end_date = moment(endDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('YYYY-MM-DD');

    const [isLoading, setIsLoading] = useState(false)
    const [formData, setFormData] = useState({ limit: 10, page: 0, direction: "desc", search: "" });
    const [totalCount, setTotalCount] = useState(0);
    const [scroll, setScroll] = useState(0);
    const notificationSystem = useRef(null);
    const [sortData, setSortData] = useState(false);
    const [billingList, setBillingList] = useState([]);
    const [showBillModal, setShowBillModal] = useState(false)
    const [categoryList, setCategoryList] = useState([]);
    const [showSearchBar, setShowSearchBar] = useState(false)
    const [selectedRow, setSelectedRow] = useState(null)
    const [showPartPaymentModal, setShowPartPaymentModal] = useState(false)
    const [openMenuRowId, setOpenMenuRowId] = useState(null);
    let history = useHistory();
    const [showPreviewModal, setShowPreviewModal] = useState(false)
    const [billNo, setBillNo] = useState("");
    const [services, setServices] = useState([])
    const [totalAmount, setTotalAmount] = useState(0)
    const [totalPaidAmount, setTotalPaidAmount] = useState(0)
    const [totalDiscountAmount, setTotalDiscountAmount] = useState(0)
    const [totalRemainingAmount, setTotalRemainingAmount] = useState(0)
    const [paymentMode, setPaymentMode] = useState("cash")
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [showRefundModal, setShowRefundModal] = useState(false);
    const [patientData, setPatientData] = useState(null)
    const [refund, setRefund] = useState(0)
    console.log(refund, "---refund---")

    const valid = current => moment().format('YYYY-MM-DD') >= moment(current).format('YYYY-MM-DD');
    const valid2 = current => {
        let today = moment().format('YYYY-MM-DD');
        let currentFormatted = moment(current).format('YYYY-MM-DD');
        return today >= currentFormatted && start_date <= currentFormatted;
    };

    const getBillingList = async (from = {}) => {
        setIsLoading(true);
        setBillingList([])
        let resp = await API.billingList({ "limit": from.limit, "offset": from.page, "order": "createdAt", "direction": from.direction, "search": from.search, startDate: start_date, endDate: end_date });
        if (resp?.data?.status === "Success" && resp?.data?.statusCode === 200) {
            setIsLoading(false);
            setBillingList(resp.data.data);
            setTotalCount(resp.data.totalCount);
        }

    }

    const _setTableOption = () => {
        if (isLoading) {
            return (
                <Loading
                    type="bars"
                    color="#000000"
                    style={{ margin: "0px auto", width: "40px" }}
                />
            );
        } else {
            return "No data found!";
        }
    };

    const rowStyleFormat = (row, rowIdx) => {
        if (row && row.visited) {
            return { backgroundColor: '#f3f1b0' };
        }
    }

    const onPageChange = (page, sizePerPage) => {
        let data = formData;
        data['page'] = page - 1;
        data['limit'] = sizePerPage;
        setFormData({ ...formData, ...data });
        getBillingList(data);

        let scrollBar = 50;
        if (scroll == page && sizePerPage < scrollBar) {
            eval('$(".ps").scrollTop(0)');
        } else if (totalCount < page * sizePerPage) {
            eval('$(".ps").scrollTop(0)');
        }
        setScroll(page)
    }

    function sortHandle() {
        let data = formData;
        data['direction'] = sortData ? "desc" : "asc";
        setFormData({ ...formData, ...data });
        getBillingList(data);
    }

    const options = {
        //onSortChange: this.onSortChange,
        clearSearch: true,
        pageStartIndex: 1, // where to start counting the pages
        paginationSize: 3,  // the pagination bar size.
        prePage: 'Prev', // Previous page button text
        nextPage: 'Next', // Next page button text
        firstPage: 'First', // First page button text
        lastPage: 'Last', // Last page button text
        //paginationShowsTotal: this.renderShowsTotal,  // Accept bool or function
        paginationPosition: 'bottom',  // default is bottom, top and both is all available
        sizePerPage: formData.limit,
        onPageChange: onPageChange,
        page: formData.page + 1,
        onSortChange: (sortName, sortOrder) => {
            console.log(sortName, "SortName", sortOrder)
            setFormData({ ...formData, direction: sortOrder });
            getBillingList({ ...formData, direction: sortOrder });
        },
        // sizePerPageList: [{
        //     text: '10', value: 10
        // }, {
        //     text: '25', value: 25
        // },
        // {
        //     text: '30', value: 30
        // },
        // {
        //     text: '50', value: 50
        // },
        // {
        //     text: 'All', value: 1000000000
        // }],
        noDataText: _setTableOption()
    };

    const srNo = (cell, row, enumObject, rowIndex) => {
        return (rowIndex + 1 + (formData.limit * formData.page))
    }

    const formatDate = (cell, row, enumObject, rowIndex) => {
        return (moment(row?.createdAt).format('DD-MM-YYYY'))
    }

    const formatPatientClinicId = (cell, row, enumObject, rowIndex) => {
        return (row?.patientData?.patientClinicId || "")
    }

    const formatPatientName = (cell, row) => {
        const fullName = `${row?.patientData?.firstName || ""} ${row?.patientData?.lastName || ""}`.trim();

        const handleClick = () => {
            history.push({
                pathname: "/bill-details",
                state: { row }
            });
        };

        return (
            <span style={{ cursor: "pointer", color: "blue" }} onClick={handleClick}>
                {fullName}
            </span>
        );
    };

    const formatPatientPhoneNumber = (cell, row, enumObject, rowIndex) => {
        return (row?.patientData?.phone || "")
    }

    const formatPurpose = (cell, row, enumObject, rowIndex) => {
        return (row?.services[0]?.item || "")
    }
    const formatPaymentStatus = (cell, row, enumObject, rowIndex) => {
        let status = row?.paymentStatus || "";

        // Extracting values from row and ensuring they are numbers
        const totalAmount = Number(row?.totalAmount || 0);
        const totalPaid = Number(row?.totalPaidAmount || 0);
        const totalRemaining = Number(row?.totalRemainingAmount || 0);
        const totalDiscount = Number(row?.totalDiscountAmount || 0);
        const refundAmount = Number(row?.refundAmount || 0);



        // Conditional logic for setting status
        if (row?.isCancelled) {
            status = "Cancelled";
        } else if (totalRemaining > 0) {
            status = "Remaining";
        } else {
            status = "Paid";
        }

        // Define style based on status
        const style = {
            backgroundColor:
                status.toLowerCase() === "paid" ? "#0c780c" :
                    status.toLowerCase() === "clear" ? "#007bff" :
                        status.toLowerCase() === "remaining" ? "orange" :
                            status.toLowerCase() === "cancelled" ? "gray" :
                                "red",
            color: "white",
            padding: "5px",
            width: "100px",
            margin: "0 auto",
            textAlign: "center"
        };

        return <div className="custom-btn-style" style={style}>{status}</div>;
    };


    const handleClearDates = () => {
        setStartDate("")
        setEndDate("")
    }

    const getPurposeString = (services = []) =>
        services.map(s => s.item).filter(Boolean).join(" ");

    const getPaymentStatus = ({
        paymentStatus = "",
        totalAmount = 0,
        totalPaidAmount = 0,
        totalRemainingAmount = 0,
        totalDiscountAmount = 0,
        refundAmount = 0,
        isCancelled = false
    } = {}) => {
        if (isCancelled) return "Cancelled";
        if (Number(totalRemainingAmount) > 0) return "Remaining";
        return "Paid";
    };

    const csvSafeValue = (val) => {
        return (val === 0 || val === "0") ? "" : (val ?? "");
    };

    const downloadCSV = () => {
        try {
            if (!billingList.length) {
                handleToastifyMessage("noData");
                return;
            }

            const headers = [
                "S.No.",
                "BillNo",
                "Date",
                "PatientId",
                "Name",
                "Phone",
                "City",
                "Purpose",
                "Amount",
                "Paid",
                "Dues",
                "Refund",
                "Discount",
                "Status",

            ];

            console.log(billingList, '---billingList')
            const rows = billingList.map((row, index) => [
                csvSafeValue(index + 1 + (formData.limit * formData.page)),
                csvSafeValue(row?.billNumber),
                csvSafeValue(row?.createdAt ? moment(row?.createdAt).format('DD-MM-YYYY') : ""),
                csvSafeValue(row?.patientData?.patientClinicId),
                csvSafeValue(`${row?.patientData?.firstName || ""} ${row?.patientData?.lastName || ""}`.trim()),
                csvSafeValue(row?.patientData?.phone),
                csvSafeValue(row?.patientData?.city),
                csvSafeValue(getPurposeString(row?.services)),
                csvSafeValue(row?.totalAmount),
                csvSafeValue(row?.totalPaidAmount),
                csvSafeValue(row?.totalRemainingAmount),
                csvSafeValue(row?.refundAmount),
                csvSafeValue(row?.totalDiscountAmount),
                csvSafeValue(getPaymentStatus(row)),
            ]);

            const csvContent = [
                headers.join(","),      // CSV Header
                ...rows.map(r => r.map(v => `"${v}"`).join(","))  // Escape values
            ].join("\n");

            const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", "BillingList.csv");
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            handleToastifyMessage("downloadSuccess");
        } catch (error) {
            console.error("Error while downloading CSV:", error);
            handleToastifyMessage("downloadError");
        }
    };


    const handleToastifyMessage = (data) => {
        let msg = "";
        switch (data) {
            case "noData":
                msg = "There is no data to download";
                break;
            case "downloadSuccess":
                msg = "CSV downloaded successfully";
                break;
            case "downloadError":
                msg = "Error while downloading CSV";
                break;
            case "createBill":
                msg = "Bill Created Successfully";
                break;
            case "updateBill":
                msg = "Bill Updated Successfully";
                break;
            default:
                msg = "Unknown action";
        }

        const notification = notificationSystem.current;
        notification.addNotification({
            title: (
                <span
                    data-notify="icon"
                    className="pe-7s-check"
                    style={{
                        fontSize: "30px",
                        color: "#fff",
                        padding: "0px !important",
                        top: "0% !important",
                    }}
                ></span>
            ),
            message: <div>{msg}</div>,
            level: "success",
            position: "tr",
            autoDismiss: 2,
        });
    };


    const getBillCategoryList = async () => {
        let resp = await API.categoryList({});
        if (resp?.data?.status === "Success" && resp?.data?.statusCode) {
            const billCategoryOptions = resp.data.data.map((ele) => {
                return {
                    label: ele?.name, value: ele?._id, ...ele
                }
            })
            setCategoryList(billCategoryOptions);
        }

    }

    const handleCloseModal = (msg = "") => {
        setSelectedRow(null)
        setShowBillModal(false)
        getBillingList(formData)
    }

    const handleShowSuccessMsg = (msg = "") => {
        handleToastifyMessage(msg)

    }

    const handleEditClick = (row) => {
        handleToggle(row)
        setShowSearchBar(false)
        setSelectedRow(row);
        setShowBillModal(true)
        const emrVisitId = row?.visitCountData?.length > 0 ? row.visitCountData[0]?._id : "";
        const currentPatientData = { visitCountData: [{ lastVisitDate: new Date() }], emrVisitId: emrVisitId, ...row?.patientData }
        setPatientData(currentPatientData)
    }

    const formatAction = (cell, row, enumObject, index) => {
        // return (
        //     row?.isToday ?
        //         <>
        //             <i
        //                 className="fa fa-pencil text-primary"
        //                 style={{ cursor: "pointer" }}
        //                 onClick={() => {
        //                     setShowSearchBar(false)
        //                     setSelectedRow(row);
        //                     setShowBillModal(true)
        //                 }}
        //             ></i>
        //             <i
        //                 class="fa fa-times text-danger"
        //                 aria-hidden="true"
        //                 onClick={(e) => getConfirmFun(row)}
        //             ></i>
        //         </>
        //         : null
        // );
        return (
            <MoreMenu
                row={row}
                index={index}
                isOpen={openMenuRowId === row._id}
                onToggle={() => {
                    handleToggle(row);
                }}
                onPrint={handlePrint}
                onRecovery={handleRecovery}
                onRefund={handleRefund}
                onEditClick={handleEditClick}
                onCancel={getConfirmFun}
            />
        );
    };

    const formatRemaining = (cell, row, enumObject, index) => {
        // Convert totalRemainingAmount to number for comparison
        const remaining = Number(row?.totalRemainingAmount);
        if (!row?.isToday) {
            return remaining > 0 ? (
                <span className="d-flex cus-justify-content-evenly align-items-center">
                    <span>{row?.totalRemainingAmount}</span>
                    <i
                        className="fa fa-credit-card-alt text-primary"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            setSelectedRow(row);
                            setShowPartPaymentModal(true)
                        }}
                    ></i>
                </span>
            ) : null;
        } else {
            return remaining > 0 ? row?.totalRemainingAmount : null;
        }
    }

    const formatBillDate = (cell, row, enumObject, index) => {
        return moment(row?.patientData?.updatedAt).format('DD-MM-YYYY')
    }

    const handleClosePartPaymentModal = (msg = "") => {
        setShowPartPaymentModal(false)
        handleToastifyMessage(msg)
        getBillingList(formData)
    }

    const getConfirmFun = (row) => {
        confirmAlert({
            title: "Confirm to Cancel",
            message: "Are you sure you want to cancel?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => cancelBill(row),
                },
                {
                    label: "No",
                },
            ],
        });
    };

    const safeNumber = (val) => {
        const num = Number(val);
        return isNaN(num) ? 0 : num;
    };

    const cancelBill = async (row) => {
        const payload = {}
        payload.id = row?._id
        payload.isCancelled = true
        payload.totalPaidAmount = "0"
        payload.refundAmount = "0"
        payload.services = row?.services
        let resp = await API.updateBill(payload)
        if (resp?.data?.status === "Success" && resp?.data?.statusCode) {
            getBillingList(formData)
        }
    }

    const onSearchChange = (e, field = "") => {
        let saveFormData = formData;
        saveFormData[field] = e.trimStart();
        saveFormData["page"] = 0;
        setFormData({ ...formData, ...saveFormData });
        getBillingList(saveFormData);
    };

    const handlePrint = (row) => {
        if (row) {
            handleToggle(row)
            setBillNo(row?.billNumber)
            const patientDetail = {
                firstName: row?.patientData?.firstName,
                lastName: row?.patientData?.lastName,
                patientClinicId: row?.patientData?.patientClinicId
            }
            setSelectedPatient(patientDetail)
            setServices(row?.services)
            setPaymentMode(row?.paymentMode)
            setTotalAmount(row?.totalAmount)
            setTotalPaidAmount(row?.isCancelled ? 0 : row?.totalPaidAmount)
            setTotalDiscountAmount(row?.totalDiscountAmount)
            setTotalRemainingAmount(row?.totalRemainingAmount)
            setRefund(row?.refundAmount || 0)
            setShowPreviewModal(true);
        }
    };

    const handleRecovery = (row) => {
        handleToggle(row)
        setSelectedRow(row);
        setShowPartPaymentModal(true);
    };

    const handleRefund = (row) => {
        handleToggle(row)
        setShowRefundModal(true);
        setSelectedRow(row);
    };

    const handleToggle = (row) => {
        setOpenMenuRowId(prev => (prev === row._id ? null : row._id));
    };

    const handleCloseRefundModal = (msg = "") => {
        setShowRefundModal(false)
        handleToastifyMessage(msg)
        getBillingList(formData)
    }

    const formatRefund = (cell, row, enumObject, index) => {
        return row?.refundAmount || "0"
    }

    const handleDateSearch = () => {
        getBillingList(formData)
    }

    const formatAmountPaid = (cell, row, enumObject, index) => {
        return row?.totalPaidAmount || ""
    }


    const handleStartDate = (date) => {
        let formatted = moment(date).format('YYYY-MM-DD');
        setStartDate(formatted);
    };
    const handleEndDate = (date) => {
        let formatted = moment(date).format('YYYY-MM-DD');
        setEndDate(formatted);
    };

    useEffect(() => {
        getBillingList(formData)
        getBillCategoryList()
    }, [])

    const formatAdjustedTotalAmount = (cell, row, enumObject, index) => {
        const paid = Number(row?.totalAmount || 0);
        const discount = Number(row?.totalDiscountAmount || 0);
        const refund = Number(row?.refundAmount || 0);
        const adjustedAmount = paid - discount + refund;
        return adjustedAmount;
    };


    return (
        <div className="main-content Billing-wrraper">
            <div>
                <NotificationSystem ref={notificationSystem} style={style} />
            </div>
            <Grid fluid>
                <Row>
                    <Col sm={6} md={2} className="form-group self-px-md-0">
                        <FormControl
                            type="text"
                            autocomplete="off"
                            name="search"
                            id="search"
                            value={formData.search ? formData.search : ""}
                            onChange={(e) => {
                                onSearchChange(e.target.value.replace(/\s+/g, " "), "search");
                            }}
                            placeholder="Search here ..."
                        />
                    </Col>
                    <Col sm={6} md={3} lg={2}>
                        <FormGroup className="d-flex align-item-baseline col-gap-5 self-mb-0">
                            <Col componentClass={ControlLabel}>From:</Col>
                            <Datetime
                                timeFormat={false}
                                dateFormat={"DD-MM-YYYY"}
                                // value={moment(startDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('DD-MM-YYYY') || ""}
                                value={startDate ? moment(startDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('DD-MM-YYYY') : ""}
                                onChange={handleStartDate}
                                isValidDate={valid}
                                inputProps={{ placeholder: "DD-MM-YYYY" }}
                                key={'start_Date' + startDate}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={6} md={3} lg={2}>
                        <FormGroup className="d-flex align-item-baseline col-gap-5 self-mb-0">
                            <Col componentClass={ControlLabel}>To:</Col>
                            <Datetime
                                timeFormat={false}
                                dateFormat={"DD-MM-YYYY"}
                                // value={moment(endDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('DD-MM-YYYY') || ""}
                                value={endDate ? moment(endDate, ['YYYY-MM-DD', 'DD-MM-YYYY']).format('DD-MM-YYYY') : ""}
                                onChange={handleEndDate}
                                isValidDate={valid2}
                                inputProps={{ placeholder: "DD-MM-YYYY" }}
                                maxDate={new Date()}
                                key={'end_Date' + endDate}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm={6} md={2} lg={1}>
                        <FormGroup className="self-mb-0">
                            <Button
                                className="btn btn-fill btn-primary"
                                onClick={(e) => handleDateSearch()}
                            >
                                Search
                            </Button>
                        </FormGroup>
                    </Col>
                    <Col sm={6} md={2} lg={1}>
                        <FormGroup className="self-mb-0">
                            <Button
                                className="btn btn-fill btn-primary"
                                onClick={(e) => handleClearDates()}
                            >
                                Clear
                            </Button>
                        </FormGroup>
                    </Col>
                    <Col sm={12} md={12} lg={4} className="d-flex cus-justify-content-between self-px-md-0">
                        {/* <FormGroup className="text-right-webkit self-mr-3 mr-14">
                            <Button
                                className="btn btn-fill btn-primary"
                                onClick={(e) => {
                                    setShowSearchBar(true);
                                    setShowBillModal(true)
                                    setSelectedRow(null);
                                    setPatientData(null)
                                }}
                            >
                                Create Bill
                            </Button>
                        </FormGroup> */}
                        <FormGroup className="text-right-webkit self-mb-0">
                            <Button
                                className="btn btn-fill btn-primary"
                                disabled={!billingList?.length > 0}
                                onClick={downloadCSV}
                            >
                                <i className="fa fa-download" style={{ marginRight: "5px" }}></i>
                                Download CSV
                            </Button>
                        </FormGroup>
                    </Col>
                </Row>
                <div className="row align-items-center mb-4">
                    <div className="col-md-12">
                        <h4 className="text-center" style={{ fontWeight: "bold" }}>Bill List</h4>
                    </div>
                </div>
            </Grid>
            <Card
                content={
                    <div className="fresh-datatables">
                        <BootstrapTable
                            deleteRow={false}
                            key={billingList}
                            data={billingList}
                            search={false}
                            multiColumnSearch={true}
                            pagination={true}
                            options={options}
                            striped
                            hover
                            condensed
                            scrollTop={"Bottom"}
                            remote={true}
                            fetchInfo={{ dataTotalSize: totalCount }}
                            trStyle={rowStyleFormat}
                        >
                            <TableHeaderColumn
                                hidden={true}
                                tdAttr={{ "data-attr": "_id" }}
                                dataField="_id"
                                isKey
                                searchable={false}
                            >
                                Id
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "#" }}
                                thStyle={{ width: "5%", textAlign: "center" }}
                                tdStyle={{ width: "5%", textAlign: "center" }}
                                dataField="sn"
                                dataFormat={srNo}
                            >
                                S.No.
                            </TableHeaderColumn>

                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "#" }}
                                thStyle={{ width: "10%", textAlign: "center" }}
                                tdStyle={{ width: "10%", textAlign: "center" }}
                                dataField="billNumber"
                            >
                                Bill No
                                <i onClick={() => {
                                    setSortData(prev => {
                                        const newSort = !prev;
                                        let data = { ...formData, direction: newSort ? "desc" : "asc" };
                                        setFormData(data);
                                        getBillingList(data);
                                        return newSort;
                                    });
                                }} style={{ cursor: 'pointer' }} class="fa fa-caret-up" aria-hidden="true"></i>
                                <i onClick={() => {
                                    setSortData(prev => {
                                        const newSort = !prev;
                                        let data = { ...formData, direction: newSort ? "desc" : "asc" };
                                        setFormData(data);
                                        getBillingList(data);
                                        return newSort;
                                    });
                                }} style={{ cursor: 'pointer' }} class="fa fa-caret-down" aria-hidden="true"></i>
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "#" }}
                                thStyle={{ width: "13%", textAlign: "center" }}
                                tdStyle={{ width: "13%", textAlign: "center" }}
                                dataFormat={formatBillDate}
                            >
                                Date
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "10%", textAlign: "center" }}
                                tdStyle={{ width: "10%", textAlign: "center" }}
                                dataField="patientClinicId"
                                dataFormat={formatPatientClinicId}
                            >
                                PatientId
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "20%", textAlign: "center" }}
                                tdStyle={{ width: "20%", textAlign: "center" }}
                                dataField="name"
                                dataFormat={formatPatientName}
                            >
                                Name
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "10%", textAlign: "center" }}
                                tdStyle={{ width: "10%", textAlign: "center" }}
                                dataField="name"
                                dataFormat={formatPatientPhoneNumber}
                            >
                                Contact
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "15%", textAlign: "center" }}
                                tdStyle={{ width: "15%", textAlign: "center" }}
                                dataField="name"
                                dataFormat={formatPurpose}
                            >
                                purpose
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "10%", textAlign: "center" }}
                                tdStyle={{ width: "10%", textAlign: "center" }}
                                dataField="paymentMode"
                            >
                                Payment Mode
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "10%", textAlign: "center" }}
                                tdStyle={{ width: "10%", textAlign: "center" }}

                                dataField="totalAmount"
                            >
                                Total Amount
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "10%", textAlign: "center" }}
                                tdStyle={{ width: "10%", textAlign: "center" }}
                                dataField="totalPaidAmount"
                            >
                                Amount Paid
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "10%", textAlign: "center" }}
                                tdStyle={{ width: "10%", textAlign: "center" }}
                                dataField="totalDiscountAmount"
                            >
                                Discount
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "12%", textAlign: "center" }}
                                tdStyle={{ width: "12%", textAlign: "center" }}
                                dataField="totalRemainingAmount"
                            >
                                Remaining
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "10%", textAlign: "center" }}
                                tdStyle={{ width: "10%", textAlign: "center" }}
                                dataFormat={formatRefund}
                            >
                                Refund
                            </TableHeaderColumn>
                            <TableHeaderColumn
                                tdAttr={{ "data-attr": "title" }}
                                thStyle={{ width: "15%", textAlign: "center" }}
                                tdStyle={{ width: "15%", textAlign: "center" }}
                                dataField="paymentStatus"
                                dataFormat={formatPaymentStatus}
                            >
                                Status
                            </TableHeaderColumn>

                            <TableHeaderColumn
                                dataFormat={formatAction}
                                dataAlign="center"
                                width="10%"
                            >
                                Action
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                }
            />
            {/* <Modal
                className="pa-patient-registration"
                show={showBillModal}
                onHide={() => setShowBillModal(false)}
                dialogClassName="modal-lg"
            >
                <Modal.Header closeButton className="Patient-headers">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        {selectedRow === null ? "Create Bill" : "Update Bill"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="Knowledge-Share card">
                    <Row>
                        <Col md={12}>
                            <Bill
                                billCategoryList={categoryList}
                                showSearchBar={showSearchBar}
                                handleCloseModal={handleCloseModal}
                                row={selectedRow}
                                handleShowSuccessMsg={handleShowSuccessMsg}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal> */}

            <Modal
                // backdrop="static"
                className="pa-patient-registration"
                show={showBillModal}
                onHide={() => setShowBillModal(false)}
                dialogClassName="modal-xl full-model"
            >
                <Modal.Header closeButton className="Patient-headers cus-mb-0">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Patient Registration
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="Knowledge-Share card patient-detail-style">
                    <Row>
                        <Col md={12}>

                            <PatientRegistration
                                parentComponent="billing"
                                onDismiss={() => setShowBillModal(false)}
                                showSearchBar={true}
                                showRegBillView={true}
                                patientData={patientData}
                            />

                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>

            <Modal
                className="pa-patient-registration"
                show={showPartPaymentModal}
                onHide={() => setShowPartPaymentModal(false)}
                dialogClassName="modal-lg"
            >
                <Modal.Header closeButton className="Patient-headers">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Add Payment
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="Knowledge-Share card">
                    <Row>
                        <Col md={12}>
                            <BillPartPayment
                                handleClosePartPaymentModal={handleClosePartPaymentModal}
                                row={selectedRow}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
            <Modal show={showPreviewModal} onHide={() => setShowPreviewModal(false)} dialogClassName="modal-lg">
                <Modal.Body>
                    <Print
                        patient={selectedPatient}
                        services={services}
                        totalAmount={totalAmount}
                        totalDiscountAmount={totalDiscountAmount}
                        totalPaidAmount={totalPaidAmount}
                        totalRemainingAmount={totalRemainingAmount}
                        refund={refund}
                        setShowPreviewModal={setShowPreviewModal}
                        billNumber={billNo}
                    />
                </Modal.Body>
            </Modal>
            <Modal
                className="pa-patient-registration"
                show={showRefundModal}
                onHide={() => setShowRefundModal(false)}
                dialogClassName="modal-lg"
            >
                <Modal.Header closeButton className="Patient-headers">
                    <Modal.Title id="example-modal-sizes-title-lg">
                        Add Payment
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="Knowledge-Share card">
                    <Row>
                        <Col md={12}>
                            <BillRefund
                                handleCloseRefundModal={handleCloseRefundModal}
                                row={selectedRow}
                            />
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default BillingList